import { cn } from "@/lib/utils";
import { ReactNode } from "@tanstack/react-router";
import { Info } from "lucide-react";
import { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function InfoBox({ children, className, ...props }: Props) {
  return (
    <div
      {...props}
      className={cn(
        "relative p-5 border border-brand-primary/60 bg-gradient-to-bl from-brand-primary/10 to-brand-primary/0 rounded-md",
        className
      )}
    >
      {children}
      <div className="absolute bg-brand-primary dark:bg-brand-primary text-white dark:text-brand-gray-950 -top-1.5 -right-1.5 p-2 border border-brand-primary/60 rounded-lg">
        <Info size={16} />
      </div>
    </div>
  );
}
